import axios from 'axios';
import { siteConfig } from '../config';

export default {
    validateGoLive({ commit }, payload) {
        const url = siteConfig.api + "apopoint/goLive";
        return new Promise((resolve, reject) => {
            axios
                .post(url, payload)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    validateStep({ commit }, { step, payload }) {
        /**
         * step: 1 | 2 | 3
         */
        const endpoints = {
            1: 'apopoint/setupStepOne',
            2: 'apopoint/setupStepTwo',
            3: 'apopoint/setupStepThree',
        };
        const url = siteConfig.api + endpoints[step];

        return new Promise((resolve, reject) => {
            axios
                .post(url, payload)
                .then(res => {
                    resolve(res.data); ƒ
                })
                .catch(err => {
                    reject(err);
                });
        });
    },



    fetchCurrentCatalogId({ commit }, catalogStatusType) {

        let apiURL = catalogStatusType == "online"
            ? siteConfig.api + 'catalog?filters[isOnline]=1'
            : siteConfig.api + 'catalog?include=catalog.catalogProductVoucherExpirationDates&filters[isActive]=1'

        return new Promise((resolve, reject) => {

            axios.get(apiURL)
                .then(function (res) {
                    commit('setCatalogData', res.data.catalog[0]);
                    resolve();
                })
                .catch(function (err) {
                    reject(err);
                })

        })

    },

    fetchCurrentEquipmentCatalogId({ commit }, catalogStatusType) {

        let apiURL = siteConfig.api + 'equipmentCatalog?filters[isActive]=1';

        return new Promise((resolve, reject) => {

            axios.get(apiURL)
                .then(function (res) {

                    commit('setEquipmentCatalogData', res.data.equipmentCatalog[0]);
                    resolve();

                })
                .catch(function (err) {
                    reject(err);
                })

        })

    },

    async getApiVersion({ commit }) {
        const res = await axios.get(siteConfig.api + 'discover/version');
        commit('setEnvType', res && res.data && res.data.environment ? res.data.environment : null);
        commit('setApiVersion', res && res.data && res.data.mwb_api ? res.data.mwb_api : '0.0.0');
    },

    async fetchLabels({ commit }, userLang) {

        let apiURL = siteConfig.api + 'label/keyValueList?language=' + userLang + '&app=cms&' + Date.now();

        const res = await axios.get(apiURL);
        commit('setLabels', { labels: res.data, lang: userLang });

        return res;

    },

    async fetchTaxonomies({ commit }) {

        const res = await axios.get(siteConfig.api + 'taxonomy?include=taxonomy.taxonomyTerms&orderBy=term.sortorder');
        commit('setTaxonomies', res.data.taxonomy);

        return res;

    },

    fetchCatalogPageElements({ commit }) {

        let apiURL = siteConfig.api + 'catalogPageElement?orderBy=sortorder';

        return new Promise((resolve, reject) => {

            axios.get(apiURL)
                .then(function (res) {

                    commit('updateCatalogPageElements', res.data.catalogPageElement);
                    resolve();

                })
                .catch(function (err) {
                    reject(err);
                })

        })

    },

    fetchCatalogPagesManufacturer({ commit }, manufacturerId) {

        return new Promise((resolve, reject) => {

            axios.get(siteConfig.api + 'catalogPage?include=catalogPage.catalog,catalogPage.catalogPageElements,catalogPage.preview,preview.siteCatalogAsset&filters[catalog.isActive]=1&filters[manufacturer]=' + manufacturerId)
                .then((res) => {
                    commit('industryPartnerHasDoublePage', res.data.catalogPage.length > 0);
                    resolve();
                })
                .catch(function (err) {
                    reject(err);
                });

        })
    },

}
